<template>
    <div style="position: relative; top: 60px; margin-left: 13px;">
        <div class="container">
            <a v-if="notes.length" :href="downloadLink">Download Here</a>
            <br/>
            <ul>
                <li v-for="note in notes" :key="note._id">
                    {{ note.createdOn | date }} - {{ note.note }} v{{ note.version }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { api } from '../framework/api';
export default {
    data() {
        return {
            notes: []
        }
    },
    computed: {
        downloadLink() {
            if(!this.notes.length) return '#';
            let recent = this.notes[0];
            return `http://olhideout.net/release/${recent.file}`;
        }
    },
    async created() {
        let data = await api.get('release');
        this.notes = data.data;
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Launcher.vue